module.exports = __webpack_public_path__ + "85c85c63e22559ef808f74f97eb685f6.MP3";